import { CompanyDTO } from '@energy-advice/easas-api';
import { create } from 'zustand';
import { UserDTO } from "../api/model/user/UserDTO";

export interface UserState {
    companyContext?: CompanyDTO ;
    currentUser?: UserDTO;
    isCurrentUserLoaded: boolean;
    setCompanyContext: (company?: CompanyDTO) => void;
    setCurrentUser: (user?: UserDTO) => void;
    getLanguage: () => string;
}

export const useUserState = create<UserState>()(
    (set,get) => ({
        companyContext: undefined,
        currentUser: undefined,
        isCurrentUserLoaded: false,
        setCompanyContext: (company?: CompanyDTO) => set(() => ({ companyContext: company })),
        setCurrentUser: (user?: UserDTO) => set(() => ({
            currentUser: user,
            isCurrentUserLoaded: true,
            companyContext: user?.accessibleCompanies.filter( c => user?.companyRef === c.companyReference )[0]
        })),

        getLanguage: () => get().currentUser?.preferences.language || 'en'
    }),
)